<template>
  <section id="workbench">
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead>
        <tr>
          <th>Option</th>
          <th>Provider</th>
          <th>Distance</th>
          <th>Duration</th>
          <th>Amount</th>
          <th>Quality</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(option, i) in optionsByCostAsc">
          <td>{{ option.optionNumber }}</td>
          <td>{{ option.serviceProviderName }}</td>
          <td>{{ option.distance + ' ' + (option.distanceType || '') }}</td>
          <td>{{ option.duration + ' ' + option.durationType }}</td>
          <td>{{ option.reportingCurrencyRate }}</td>
          <td>{{ option.providerQuality || '' }}</td>
          <td>
            <div
              v-if="option.details[0].rateIdentifier === currentSelection.details[0].rateIdentifier"
              class="btn btn-default sq disabled">
              Selected
            </div>
            <div v-else>
              <div class="btn btn-primary sq" @click="$emit('comparison', option.optionNumber)">
                <i class="fa fa-search"></i>
              </div>
              <div class="btn btn-success sq" @click="makeChoice(option)">
                <i class="fa fa-check"></i>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- @todo delete if not being used
    <div v-if="viewing !== false">
      <h4>Workbench option number {{ options[viewing].optionNumber }}</h4>
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead>
          <tr>
            <th>Detail</th>
            <th>Value</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(value, detail) in options[viewing].details[0]">
            <td>{{ deCamel(detail) }}</td>
            <td>{{ getVal(value, detail) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    -->
  </section>
</template>
<script>
export default {
  name: 'WorkBench',
  data () {
    return {
      viewing: false
    }
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    currentSelection: {
      type: Object,
      required: true
    }
  },
  computed: {
    optionsByCostAsc () {
      const arr = this.options
      const ret = arr.sort((a, b) => {
        let sortVal = a.reportingCurrencyRate - b.reportingCurrencyRate
        let optionVal = a.optionNumber - b.optionNumber
        return sortVal === 0 ? optionVal : sortVal
      })
      return ret
    },
    providersCodeToName () {
      return this.$store.getters['quote/providersCodeToName']
    }
  },
  methods: {
    makeChoice (option) {
      this.$emit('comparison', false)
      this.$emit('choice-made', option)
    },
    deCamel (string) {
      return string !== 'expiresAsDate' ? string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()) : 'Expires On Date'
    },
    getVal (val, detail) {
      if (['expiresAsDate', 'expiresOnDate', 'expires'].indexOf(detail) > -1) {
        return new Date(val).toString()
      }
      return val
    }
  },
  mounted () {
    /*
    let providers = this.options.filter(({serviceProvider}) => !this.providersCodeToName.hasOwnProperty(serviceProvider))
    if (providers.length) {
      this.$store.dispatch('quote/addProviders', providers.map(({serviceProvider}) => serviceProvider))
    }
    */
  }
}
</script>
<style scoped>
  header {
    position: relative;
  }
  .ion-close-round {
    position: absolute;
    cursor: pointer;
  }
  .ion-close-round.sm {
    top: 0px;
    right: 0px;
  }
  .input-tr td {
    padding: 0 !important;
    height: 37px;
  }
  .input-tr .is-input {
    height: 100%;
    width: 100%;
    border: none;
    padding-left: 4px;
  }
  #item-rate-breakdown-window {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2222;
    background: rgba(51, 80, 86, 0.6);
  }
  #rate-breakdown-box {
    margin: 40px auto 0 auto;
    background: #fff;
    width: 50%;
    padding:10px;
    max-height: 90%;
    overflow: auto;
  }
  /* Large Devices, Wide Screens */
  @media only screen and (max-width : 1200px) {
    #rate-breakdown-box {
      width: 60%;
    }
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width : 992px) {
    #rate-breakdown-box {
      width: 75%;
    }
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width : 768px) {
    #rate-breakdown-box {
      width: 85%;
    }
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width : 320px) {
    #rate-breakdown-box {
      width: 95%;
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.6;
    }
  }
  @keyframes fadeOut {
    from {
      opacity:0.6;
    }
    to {
      opacity: 0;
    }
  }
  thead {
    background-color: #428bca;
    color: #fff;
  }

  @media(max-width: 479px) {
    .full-w-sm {
      width: 100%;
    }
    .half-w-sm {
      width: 49%;
    }
  }
  tr td:nth-child(2) {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/modules/quote/components/WorkBench.vue